import CryptoJS from "crypto-js";

const defaultKey = import.meta.env.VITE_AES_KEY;
const defaultIv = import.meta.env.VITE_AES_IV;

class Crypto {
  static async AesEncrypt(data) {
    return await this.AesEncryptWithKeyIv(defaultKey, defaultIv, data);
  }

  static async AesEncryptWithKeyIv(key, iv, data) {
    const Encrypt = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      CryptoJS.enc.Latin1.parse(key),
      {
        iv: CryptoJS.enc.Latin1.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();

    return Encrypt;
  }

  static async AesDecrypt(data) {
    return await this.AesDecryptWithKeyIv(defaultKey, defaultIv, data);
  }

  static async AesDecryptWithKeyIv(key, iv, data) {
    const Decrypt = JSON.parse(
      CryptoJS.AES.decrypt(data, CryptoJS.enc.Latin1.parse(key), {
        iv: CryptoJS.enc.Latin1.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }).toString(CryptoJS.enc.Utf8)
    );

    return Decrypt;
  }
}

export default Crypto;
